module.exports = __webpack_public_path__ + "static/glotov-3ae186b6c4b871aa1dcdcc15d08b6b3e.jpg";